import * as React from 'react'

const SvgExamPaperIcon = ({ stroke }) => (
  <svg
    width="19"
    height="23"
    viewBox="0 0 19 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 11.9V6.20002C17 4.51987 17 3.67979 16.673 3.03805C16.3854 2.47357 15.9265 2.01462 15.362 1.727C14.7202 1.40002 13.8802 1.40002 12.2 1.40002H5.8C4.11984 1.40002 3.27976 1.40002 2.63803 1.727C2.07354 2.01462 1.6146 2.47357 1.32698 3.03805C1 3.67979 1 4.51987 1 6.20002V16.6C1 18.2802 1 19.1203 1.32698 19.762C1.6146 20.3265 2.07354 20.7854 2.63803 21.073C3.27976 21.4 4.11984 21.4 5.8 21.4H9M11 10.4H5M7 14.4H5M13 6.40002H5M11.5 18.4L13.5 20.4L18 15.9"
      stroke={stroke || '#A4BCFD'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgExamPaperIcon
